import React from 'react';
import 'devextreme/dist/css/dx.light.css';
import TabPanel, {Item} from 'devextreme-react/tab-panel';
import { saveAs } from "file-saver";


const ProductDetail = ({res}) => {
    const styleTD = {
        textAlign : "left",
        border:"none"
    }



    const buttonStyle = {
        height: '35px',
        padding: '1%',
        border: '1px solid red',
        backgroundColor: 'red',
        borderRadius: '12px',
        color: '#fff',
        margin: '2%',
        cursor:"pointer"
    }
    
    
    const profilePic = res.product[0].productImageList.contentItems.filter(i=> i.__typename === 'ProductImage')
    const Advantages = res.product[0].productAdvantageList.contentItems.filter(i=> i.__typename !== 'LabelForAdvantage')
    const TableData = res.product[0].productPickedComplementaryInfoList
    
    const productDrawingList = res.product[0].productDrawingList.contentItems.filter(i=> i.__typename !== 'LabelForDrawing')
    const catalog = res.product[0].productCatalogList.contentItems.filter(i=> i.__typename !== 'LabelForCatalog')
    const name = res.product[0].displayText

    var result = [];

    if (res.product[0].productPickedComplementaryInfoList !== null) {
        result =  TableData.contentItems.filter(i=> i.__typename !== 'LabelForTechnicalInfo').reduce((r, a) => {
           
            
            if (a.complementaryInfo.contentItems[0].parentComplementaryInfo && a.complementaryInfo.contentItems[0].parentComplementaryInfo.contentItems.length > 0) {
                
                r[a.complementaryInfo.contentItems[0].parentComplementaryInfo.contentItems[0].id] = r[a.complementaryInfo.contentItems[0].parentComplementaryInfo.contentItems[0].id] || [];
                r[a.complementaryInfo.contentItems[0].parentComplementaryInfo.contentItems[0].id].push(a);
            } else {
                r[a.complementaryInfo.contentItems[0].id] = r[a.complementaryInfo.contentItems[0].id] || [];
                r[a.complementaryInfo.contentItems[0].id].push(a);
               
            }
            
            return r;
        }, Object.create(TableData.contentItems.filter(x => x.__typename !== 'LabelForTechnicalInfo' && !(x.complementaryInfo.contentItems[0] && x.complementaryInfo.contentItems[0].parentComplementaryInfo))));
        
    }

    const saveFile = (url) => {
        saveAs(
            process.env.REACT_APP_BASE_URL + url
        );
      }

    return (
        <div className="product-details-top">
             <div className="row">
                <div className="col-md-5">
                    <div className="product-pic mb-sm-35" style={{display:"flex"}}>
                        <img src={process.env.REACT_APP_BASE_URL + profilePic[0].productImage.urls[0]} alt={profilePic[0].productImage.displayText} style={{margin:'auto', maxWidth:"40%"}}/>
                    </div>
                </div>

                <div className="col-md-7 ml-auto">
                    <div className="product-desc">
                        <h2>{name}</h2>
                        <h5>Advantages</h5>
                        {/* <p dangerouslySetInnerHTML={{__html: bio}}/> */}

                        <div className="product-social-icons mt-25" style={{maxWidth: '70%'}}>
                            <ul>
                                {Advantages.map(adv => 
                                    <li style={{listStyleType: 'circle'}}>
                                       <p dangerouslySetInnerHTML={{__html:adv.htmlBody.html}} />
                                    </li>
                                )}
                           </ul>
                        </div>

                        {/* <div className="contact-info mt-25">
                            <p><strong>ویژگی 1</strong> <span dangerouslySetInnerHTML={{__html: address}}/></p>
                            <p><strong>ویژگی2</strong> {phone}</p>
                            <p><strong>ویژگی3</strong> {email}</p>
                            <p><strong>ویژگی4</strong> {website}</p>
                        </div> */}
                    </div>
                </div>
            </div>

            <br/>
            <br/>
            <br/>
            <TabPanel>
                
                <Item title={res.product[0].productAdvantageList.contentItems.filter(i=> i.__typename === 'LabelForAdvantage')[0].displayText}> 
                    <ul style={{margin:'3%', maxWidth:'63%'}}>
                        {Advantages.map((adv,l) => 
                            <li key={l} style={{listStyleType: 'circle'}}>
                                <p dangerouslySetInnerHTML={{__html:adv.htmlBody.html}} /><br/>
                            </li>
                        )}
                    </ul>
                </Item>
                
                <Item title={ res.product[0].productPickedComplementaryInfoList.contentItems.filter(x => x.__typename === "LabelForTechnicalInfo")[0].labelValue }>
                    <table style={{direction:"ltr", display:"absolute", left:"0", margin:"3%", float:"left"}}>
                        {
                            Object.values(result).map((i,l)=>
                           
                               
                                i.length===1?
                                <tr key={l} style={{borderBottom:"1px solid gray", padding:"2%"}}>
                                    <td style={{float:"left", border:"none"}}>{i[0].complementaryInfo.contentItems[0].displayText}</td>
                                    <td style={styleTD}>{" "}</td>
                                    <td style={styleTD}>{i[0].complementaryInfoValue}</td>
                                </tr>
                                :
                                
                                <tr key={l} style={{borderBottom:"1px solid gray", padding:"2%"}}>
                                    <td style={{float:"left", border:"none"}} rowspan={i.length}>{i[0].complementaryInfo.contentItems[0].parentComplementaryInfo.contentItems[0].displayText}</td>
                                    <td style={styleTD}>
                                        {
                                            i.map((j,l)=>
                                                <tr key={l}>
                                                    <td style={{border:"none"}}>
                                                        {j.complementaryInfo.contentItems[0].userTitle}
                                                    </td>
                                                </tr>
                                            )
                                        }

                                    </td>

                                    <td style={styleTD}>
                                        {
                                            i.map((j,l)=>
                                                <tr key={l}>
                                                    <td style={{border:"none"}}>
                                                        {j.complementaryInfoValue}
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </td>
                                </tr>
                                )
                        }
                        
                    </table>
                </Item>

                <Item title={res.product[0].productDrawingList.contentItems.filter(i=> i.__typename === 'LabelForDrawing')[0].displayText}>
                    <img 
                    src={process.env.REACT_APP_BASE_URL + productDrawingList[0].drawingMedia.urls[0]} style={{float:"left"}}
                     
                    />
                </Item>
                
                <Item title={res.product[0].productCatalogList.contentItems.filter(i=> i.__typename === 'LabelForCatalog')[0].displayText}>
                    <div style={{width:'40%', height:'100%', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', margin:"0 auto"}}>
                        <div style={buttonStyle} onClick={()=>saveFile(catalog[0].catalogFile.urls[0])}>دانلود کاتالوگ </div>
                        <img src={process.env.REACT_APP_BASE_URL + catalog[0].catalogPreview.urls[0]} style={{margin:"1% 2%" , width:'45%', border:"1px solid gray"}} />
                    </div>
                    
                </Item>

            </TabPanel>
               
        </div>
        // </div>
    );
};

export default ProductDetail;
